// THE ONE PAGE TREE INSIDE A SHELL THAT DOES NOT MOVE.
//
// Route changes used to replace the entire page on one painted frame. The header arrived
// first, fast table reads left a bounded blank below it, and the rows appeared a few frames
// later. Every state was individually correct; the hard cut between them made the sequence
// read as a rendering fault.
//
// The first version animated the incoming DOM from opacity zero. It deleted the old page in
// the same commit, however, so a module sidebar appearing or disappearing still moved the
// content 224px on one visible frame; the fade merely brought that moved page out of a blank
// canvas. It also keyed this wrapper by every pathname, remounting a whole master/detail
// screen when only the selected message or notice changed.
//
// Real page replacements now opt into React Router's View Transition support at the link
// that starts them. The browser snapshots the old and new viewport without placing a second
// accessible page in the DOM, and `app.css` gives that compositor cross-fade the shared page
// timing token. Quick views, master/detail selection and pane-origin navigation do not opt
// in. This wrapper therefore owns layout only: no key, no Motion runtime and no second
// animation engine around the same navigation.

import type { ReactNode } from "react";

export function RouteStage({ children }: { readonly children: ReactNode }) {
  return (
    <div data-slot="route-stage" className="flex min-h-0 w-full flex-1 flex-col">
      {children}
    </div>
  );
}
